<template>
  <el-row style="width: 100%">
    <!-- Logo区域 -->
    <el-col :span="ispc?4:15">
      <p class="navbar__title" style="width: 240px">
        <a style="color: white; font-size: 0.9em">
          <el-image style="width: 56px;
    float: left;
    padding-top: 28px;
    padding-left: 9px;
    padding-right: 2px;" v-show="ispc"
                    src="data:image/png;base64,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"></el-image>
          斯迪克进销存系统</a>
      </p>
    </el-col>

    <!-- 菜单区域 -->
    <el-col :span="ispc?16:0" v-show="ispc" class="navbar__menu-box" style="padding-left: 10px">
      <el-menu
          :unique-opened="true"
          :default-active="defaultActive"
          style="border: 0; background: transparent;"
          class="el-menu-demo el-menu el-menu--horizontal navbar__menu"
          mode="horizontal"
          @select="handleSelect"
      >
        <el-menu-item index="sy" style="padding-left:20px">首页</el-menu-item>
        <el-menu-item v-if="role.includes('wlck')" index="ksck">快速出库</el-menu-item>

        <el-menu-item v-if="cdone.jbgn" index="jbgn">基本功能</el-menu-item>
        <el-menu-item v-if="user==='admin'" index="xtgl">系统管理</el-menu-item>
<!--        <el-submenu v-if="cdone.jbgn" index="kphd">
          <template slot="title" style="color: white !important;">进入系统</template>

          <el-menu-item v-if="cdone.ksck" index="ksck">快速出库</el-menu-item>
          <el-menu-item v-if="cdone.xtgl" index="xtgl">系统管理</el-menu-item>
          <el-menu-item v-if="cdone.jbgn" index="jbgn">基本功能</el-menu-item>
        </el-submenu>-->
      </el-menu>
    </el-col>

    <!-- 用户信息和退出区域 -->
    <el-col :span="ispc?4:7" class="navbar__user-box">
      <div class="user-container">
        <el-dropdown @command="handleUserCommand">
          <span class="el-dropdown-link">
            <el-avatar size="small" style="margin-right: 8px;">
              <i class="el-icon-user-solid"></i>
            </el-avatar>
            <p style="color: white">{{userInfo.username}}</p>
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item disabled>
              <i class="el-icon-user"></i>{{'用户：'+userInfo.username}}
            </el-dropdown-item>
            <el-dropdown-item disabled>
              <i class="el-icon-office-building"></i> {{'部门：'+userInfo.dept}}
            </el-dropdown-item>
            <el-dropdown-item divided command="logout">
              <i class="el-icon-switch-button"></i> 退出登录
            </el-dropdown-item>
            <el-dropdown-item divided command="upqwe">
              <i class="el-icon-key"></i> 修改密码
            </el-dropdown-item>
            <el-dropdown-item divided command="showbig" v-if="checkPrower('showbig')" >
              <i class="el-icon-picture-outline-round"></i> 大屏模式
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </el-col>

  </el-row>
</template>

<script>
export default {
  data() {
    return {
      activeIndex: '1',

      datetime: '',
      rolelist: [],
      role:[],
      ispc: true,
      user:null,
      cdone: {
        ksck: true,
        ksrk: true,
        jbgn: true,
        xtgl: true,
      },
      userInfo: {
        username:localStorage.getItem('username') || '',
        dept:localStorage.getItem('dept')|| '',
      }
    };
  },
  created() {

    this.ispc = 'pc' === localStorage.getItem('deviceType')
    this.getrole();
  },
  methods: {
    checkPrower(permission) {
      const qx = localStorage.getItem('qx');
      return qx && qx.includes(permission);
    },
    handleSelect(key, keyPath) {
      this.$emit('menu-select', key);
    },

    handleUserCommand(command) {
      if (command === 'logout') {
        this.$confirm('确认退出吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // 这里添加实际的退出逻辑
          // 清除用户信息，跳转到登录页
          localStorage.removeItem('token');
          localStorage.removeItem('isLoggedIn')
          localStorage.removeItem('username')
          this.$message.success('已退出')
          this.$router.push('/login');
          window.location.reload();
        }).catch(() => {
          // 用户取消退出
        });
      }else if(command==='upqwe'){
          this.$emit('upqwe', true);
      }else if(command==='showbig'){
        this.$emit('showbig', true);
      }
    },

    // 获取当前时间
    timeNow(timeStamp) {
      let year = new Date(timeStamp).getFullYear();
      let month = new Date(timeStamp).getMonth() + 1 < 10 ? "0" + (new Date(timeStamp).getMonth() + 1) : new Date(timeStamp).getMonth() + 1;
      let date = new Date(timeStamp).getDate() < 10 ? "0" + new Date(timeStamp).getDate() : new Date(timeStamp).getDate();
      let hh = new Date(timeStamp).getHours() < 10 ? "0" + new Date(timeStamp).getHours() : new Date(timeStamp).getHours();
      let mm = new Date(timeStamp).getMinutes() < 10 ? "0" + new Date(timeStamp).getMinutes() : new Date(timeStamp).getMinutes();
      let ss = new Date(timeStamp).getSeconds() < 10 ? "0" + new Date(timeStamp).getSeconds() : new Date(timeStamp).getSeconds();
      this.datetime = year + "年" + month + "月" + date + "日  " + "星期" + '日一二三四五六'.charAt(new Date().getDay()) + " " + hh + ":" + mm + ':' + ss;
    },
    // 实时刷新当前时间，格式化
    nowTimes() {
      this.timeNow(new Date());
      setInterval(this.nowTimes, 1000);
      this.clear();
    },
    // 清除定时器
    clear() {
      clearInterval(this.nowTimes);
      this.nowTimes = null;
    },
    getrole() {
      // 获取角色权限逻辑...
     this.user = localStorage.getItem("user")

      this.$request.postHttp({
        url: "/system/getonecd",
        params: {user: this.user},
        success: (data) => {
          this.userInfo = data.data
          if (this.userInfo != null) {
            localStorage.setItem('username',this.userInfo.username);

            localStorage.setItem('dept',this.userInfo.dept);
            localStorage.setItem('qx',this.userInfo.qx);
            this.role=localStorage.getItem("qx")
          }
        },
        error: (error) => {
          console.error("Error:", error);
          // 执行失败时的操作
        },
      })

    },
  },
  mounted() {
    this.nowTimes();
  },
  computed: {
    defaultActive: function () {
      return this.$route.path.replace('/', '');
    }
  },
  beforeDestroy() {
    this.clear();
  }
};
</script>

<style scoped>
/* Logo 区域：橙黄渐变背景 */
.navbar__logo-box {
  background: linear-gradient(90deg, #FF8C00, #FFB74D);
  color: white;
  border-radius: 0 0 8px 0;
}

/* 菜单区域 */
.navbar__menu-box {
  background: none;
  display: flex;
  align-items: center;
}

/* 用户信息区域 - 改为Flex布局实现居中 */
.navbar__user-box {
  background: none;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 20px;
}

/* 新增容器确保垂直居中 */
.user-container {
  display: flex;
  align-items: center;
  height: 60px; /* 与导航栏高度一致 */
}

/* 用户下拉菜单样式 */
.el-dropdown-link {
  cursor: pointer;
  color: white;
  display: flex;
  align-items: center; /* 确保内部元素垂直居中 */
  font-size: 14px;
  height: 60px; /* 与导航栏高度一致 */
  line-height: normal; /* 覆盖默认行高 */
}

.el-dropdown-link:hover {
  color: #FFB74D;
}

.el-avatar {
  background-color: #FF8C00;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 横向菜单 */
.navbar__menu {
  background: transparent !important;
}

/* 菜单项默认样式 */
.navbar__menu .el-menu-item {
  color: #ffffff;
  font-weight: 500;
  padding: 0 20px 0 20px;
  height: 60px;
  line-height: 60px;
  display: flex;
  align-items: center; /* 确保菜单项垂直居中 */
}

/* 标题样式 */
.navbar__title {
  min-width: 240px;
  margin: 0;
  height: 60px;
  line-height: 60px;
  font-size: 1.5em;
  font-weight: bold;
  text-align: center;
}

.navbar__title a {
  color: white !important;
  text-decoration: none;
}

/* 整体 Navbar 高度统一 */
.el-row {
  height: 60px;
  align-items: center;
}

/* 确保下拉菜单图标垂直居中 */
.el-icon-arrow-down {
  display: flex;
  align-items: center;
  margin-left: 4px;
}

/* 修改 "进入系统" 子菜单标题样式 */
>>> .el-menu--horizontal > .el-submenu .el-submenu__title {
  color: #ffffff !important; /* 强制设置为白色 */
  height: 60px;
  line-height: 60px;
  border-bottom: 2px solid transparent;
}

/* 悬浮时也保持白色 */
>>> .el-menu--horizontal > .el-submenu:focus .el-submenu__title,
>>> .el-menu--horizontal > .el-submenu:hover .el-submenu__title {
  color: #ffffff !important; /* 悬浮时也保持白色 */
}

/* 主菜单项悬浮样式 */
>>> .el-menu--horizontal > .el-menu-item:not(.is-disabled):focus,
>>> .el-menu--horizontal > .el-menu-item:not(.is-disabled):hover {
  background-color: #fff3e0 !important;
  color: #FF8C00 !important;
}

>>> .el-menu--horizontal > .el-submenu .el-submenu__title:hover {
  background-color: #fff3e0 !important;
  color: #FF8C00 !important; /* 悬浮时也保持白色 */
}

>>> .el-menu--horizontal > .el-menu-item.is-active {
  color: #FFFFFF
}

.el-menu--horizontal .el-menu-item:not(.is-disabled):focus, .el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
  outline: 0;
  color: #FF8C00;
}

.el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
  border-bottom: 2px solid #f7f7f7 !important;
  color: #0d56ea;
}

</style>